import errorLogger from '@/utils/errorLogger';
import { useLocation } from '@reach/router';
import { useEffect, useState } from 'react';
import { z } from 'zod';

const dataQueryParamSchema = z.object({
  name: z.string(),
  email: z.string().email(),
  login: z.string(),
  organizations: z.array(
    z.object({
      key: z.string(),
      name: z.string(),
      status: z.string().optional(),
      loc: z.string().optional(),
      country: z.string().optional(),
    })
  ),
});

export type DataQueryParam = z.output<typeof dataQueryParamSchema>;

const useGetDataQueryParam = () => {
  const [values, setValues] = useState<DataQueryParam | null>(null);
  const location = useLocation();

  useEffect(() => {
    try {
      const encodedString = new URLSearchParams(location.search).get('d');
      if (encodedString) {
        setValues(dataQueryParamSchema.parse(JSON.parse(window.atob(encodedString))));
      }
    } catch (error) {
      errorLogger(error);
    }
  }, [location.search, setValues]);

  return values;
};

export default useGetDataQueryParam;
